/* eslint-disable import/prefer-default-export */
import { extractNumber } from '@cred/shared/utils'

const MIN_MAX_ERROR = 'Please enter an amount between $1,000 and $350,000'
const REQUIRED_ERROR = 'Please complete this field'

export const minMaxLoanAmount = (value) => {
  const numberValue = extractNumber(value)
  let error

  if (value === '' || Number.isNaN(value)) {
    error = REQUIRED_ERROR
  } else if ((value === 0 && Number.isNaN(numberValue)) || numberValue === 0) {
    error = MIN_MAX_ERROR
  } else if (numberValue < 1000 || numberValue > 350000) {
    error = MIN_MAX_ERROR
  }

  return error
}
